/* eslint-disable yola/react/prop-types */
import React, { Fragment } from 'react';
import { designSystem } from '@yola/ws-ui';
import BlockSettingsOptions from '../components/block-settings-options';
import BlockBackgroundContainer from '../containers/block-background-container';
import SwitchLayoutBlock from '../components/switch-layout-block';
import BlockSettingsOptionBox from '../components/block-settings-option-box';
import {
  BLOCK_SETTINGS_APPEARANCE_TAB_ID,
  BLOCK_SETTINGS_LAYOUT_TAB_ID,
} from '../constants/common';
import { SURFACES, SURFACES_PRIMARY, SURFACES_SECONDARY } from '../constants/display-options';
import { CONTAINER_WIDTH_OPTION_ID } from '../constants/container-width';

const { TabsList, Tab, TabsContentList, TabContent } = designSystem;

const layoutOptionsIds = ['clean_url_selector', 'product_category', 'items_count'];

const appearanceOptionsIds = [
  SURFACES,
  SURFACES_PRIMARY,
  'fullscreen',
  'whitespace_top',
  'whitespace_bottom',
  'animation',
  'animation_speed',
  'animation_direction',
  'media_column_width',
  'space_between',
  'fullwidth',
  CONTAINER_WIDTH_OPTION_ID,
  SURFACES_SECONDARY,
  'expanded_items',
  'multiple',
  'content_direction',
  'vertical_alignment',
  'horizontal_alignment',
  'feature_direction',
  'button_placement',
  'columns',
  'stickup',
  'border',
  'shadow',
  'gradient',
  'show_background_image',
  'filter',
  'overlay',
  'overlay_opacity',
  'filter_media',
  'media_decoration',
  'fill_item',
  'logo_alignment',
  'border_bottom',
  'border_width',
];

const getBlockSettingsTabs = ({
  captions: { tabs },
  options: { optionalChildren, displayOptions: display },
  blockItems,
  isBlockLayoutSwitchingDisabled,
  displayBlockLayout,
  timestamp,
  updateSharedData,
}) => {
  const safeOptionalChildren = optionalChildren || [];
  const shouldDisplayLayoutSwitching =
    !isBlockLayoutSwitchingDisabled &&
    safeOptionalChildren.filter((option) => option.isEnabled).length > 0;

  const displayOptionsMap = display.reduce((accum, item) => {
    const accumReference = accum;

    accumReference[item.id] = item;

    return accumReference;
  }, {});

  const [surfaces] = display;
  const blockLayoutOptions = layoutOptionsIds.map((id) => displayOptionsMap[id]).filter(Boolean);

  const items = [...safeOptionalChildren, ...blockLayoutOptions];

  const appearanceOptions = appearanceOptionsIds.map((id) => displayOptionsMap[id]).filter(Boolean);

  return (
    <Fragment>
      <TabsList variant="fullWidth">
        <Tab tabId={BLOCK_SETTINGS_LAYOUT_TAB_ID} label={tabs.layout} disabled={!items.length} />
        <Tab tabId={BLOCK_SETTINGS_APPEARANCE_TAB_ID} label={tabs.appearance} />
      </TabsList>
      <TabsContentList>
        <TabContent tabId={BLOCK_SETTINGS_LAYOUT_TAB_ID}>
          {blockItems.length > 1 && shouldDisplayLayoutSwitching && (
            <BlockSettingsOptionBox marginBottom="spacing-s">
              <SwitchLayoutBlock displayBlockLayout={displayBlockLayout} />
            </BlockSettingsOptionBox>
          )}
          <BlockSettingsOptions keySalt={`${timestamp}-${surfaces.value}`} items={items} />
        </TabContent>
        <TabContent tabId={BLOCK_SETTINGS_APPEARANCE_TAB_ID}>
          <BlockBackgroundContainer withDivider={appearanceOptions?.length > 0} />
          <BlockSettingsOptions
            keySalt={`${timestamp}-${surfaces.value}`}
            items={appearanceOptions}
            updateSharedData={updateSharedData}
            withDivider
          />
        </TabContent>
      </TabsContentList>
    </Fragment>
  );
};

export default getBlockSettingsTabs;
